import React, { useRef } from 'react'

import { SwiperNavigationButtons } from '../../SwiperNavigationButtons'
import { TeamsSlider } from './TeamsSlider'

export default function Teams({ organizations }) {
  const navigationPrevRef = useRef(null)
  const navigationNextRef = useRef(null)

  if (!organizations?.length) return null

  return (
    <section className="spacer">
      <div className="section-heading">
        <h1>Teams</h1>
        <SwiperNavigationButtons
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
        />
      </div>
      <div>
        <TeamsSlider
          organizations={organizations}
          navigationPrevRef={navigationPrevRef}
          navigationNextRef={navigationNextRef}
        />
      </div>
    </section>
  )
}
